(function () {
  const initGallery = (root) => {
    const gallery = root.querySelector('[data-se-gallery]');
    if (!gallery) return;

    const image = gallery.querySelector('[data-se-main-image]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-se-thumb]'));
    const prev = gallery.querySelector('[data-se-gallery-prev]');
    const next = gallery.querySelector('[data-se-gallery-next]');
    let active = Math.max(0, thumbs.findIndex((thumb) => thumb.getAttribute('aria-current') === 'true'));

    const setActive = (index) => {
      if (!image || thumbs.length === 0) return;
      active = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[active];
      const src = thumb.dataset.imageSrc;
      const srcset = thumb.dataset.imageSrcset;
      const alt = thumb.dataset.imageAlt || '';

      if (src) image.src = src;
      if (srcset) image.srcset = srcset;
      image.alt = alt;

      thumbs.forEach((item, itemIndex) => {
        item.setAttribute('aria-current', itemIndex === active ? 'true' : 'false');
      });
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => setActive(index)));
    prev && prev.addEventListener('click', () => setActive(active - 1));
    next && next.addEventListener('click', () => setActive(active + 1));
  };

  const initQuantity = (root) => {
    root.querySelectorAll('[data-se-quantity]').forEach((quantity) => {
      const input = quantity.querySelector('input');
      if (!input) return;

      quantity.querySelectorAll('[data-se-qty]').forEach((button) => {
        button.addEventListener('click', () => {
          const step = Number(button.dataset.seQty) || 0;
          const min = Number(input.min) || 1;
          const value = Math.max(min, (Number(input.value) || min) + step);
          input.value = String(value);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  };

  const initTabs = (root) => {
    const tabs = Array.from(root.querySelectorAll('[data-se-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-se-tab-panel]'));
    if (!tabs.length || !panels.length) return;

    const selectTab = (id) => {
      tabs.forEach((tab) => {
        const selected = tab.dataset.seTab === id;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        panel.setAttribute('aria-hidden', panel.dataset.seTabPanel === id ? 'false' : 'true');
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => selectTab(tab.dataset.seTab));
    });
  };

  const initCopyCode = (root) => {
    root.querySelectorAll('[data-se-copy-code]').forEach((button) => {
      button.addEventListener('click', async () => {
        const code = button.dataset.seCopyCode || '';
        try {
          await navigator.clipboard.writeText(code);
          const oldText = button.textContent;
          button.textContent = 'Copied';
          window.setTimeout(() => {
            button.textContent = oldText;
          }, 1400);
        } catch (error) {
          button.textContent = code;
        }
      });
    });
  };

  const initDynamicCheckout = (root) => {
    root.querySelectorAll('[data-se-dynamic-checkout]').forEach((button) => {
      button.addEventListener('click', () => {
        const paymentButton = root.querySelector('.shopify-payment-button__button');
        if (paymentButton) paymentButton.click();
      });
    });

    root.querySelectorAll('[data-se-more-options]').forEach((button) => {
      button.addEventListener('click', () => {
        const moreOptions = root.querySelector('.shopify-payment-button__more-options');
        if (moreOptions) {
          moreOptions.click();
          return;
        }
        const paymentButton = root.querySelector('.shopify-payment-button__button');
        if (paymentButton) paymentButton.click();
      });
    });
  };

  const initAjaxAddToCart = (root) => {
    root.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      if (form.closest('product-form-component') && customElements.get('product-form-component')) return;
      if (form.dataset.seAjaxCartReady === 'true') return;
      form.dataset.seAjaxCartReady = 'true';

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        const submitButton = form.querySelector('[type="submit"][name="add"], .sibrille-edishine-pdp__submit');
        const formData = new FormData(form);
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((item) => item instanceof HTMLElement ? item.dataset.sectionId : '')
          .filter(Boolean);

        if (sectionIds.length) {
          formData.set('sections', sectionIds.join(','));
          formData.set('sections_url', window.location.pathname);
        }

        if (submitButton) submitButton.disabled = true;

        try {
          const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
          });
          const data = await response.json();

          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Unable to add this item to cart.');
          }

          let cart = null;
          try {
            const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
            cart = await cartResponse.json();
          } catch (error) {
            cart = null;
          }

          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart || data,
              sourceId: form.id || 'sibrille-edishine-pdp',
              data: {
                source: 'product-form-component',
                itemCount: Number(formData.get('quantity')) || 1,
                productId: root.dataset.productId || '',
                variantId: String(formData.get('id') || ''),
                sections: data.sections || {},
              },
            },
          }));
        } catch (error) {
          document.dispatchEvent(new CustomEvent('cart:error', {
            bubbles: true,
            detail: {
              sourceId: form.id || 'sibrille-edishine-pdp',
              data: {
                message: error.message,
                description: error.message,
                errors: error.message,
              },
            },
          }));
          window.alert(error.message);
        } finally {
          if (submitButton) submitButton.disabled = false;
        }
      });
    });
  };

  const init = () => {
    document.querySelectorAll('[data-sibrille-edishine-pdp]').forEach((root) => {
      initGallery(root);
      initQuantity(root);
      initTabs(root);
      initCopyCode(root);
      initDynamicCheckout(root);
      initAjaxAddToCart(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
